






import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop } from 'vue-property-decorator';
@Component
export default class Example extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() photo!: string;
  @Prop() title!: string;
  @Prop() size!: string;

  get getPhoto ():string {
    return this.photo
      ? process.env.VUE_APP_IMAGE_SERVER + '/' + this.photo
      : require('@/assets/img/logo/white.svg');
  }

  get getTitle () {
    return this.photo ? this.title : this.$t('app_name');
  }
}
